<template>
  <div class="teller-profile">
    <div v-if="!!tellerInfo && !!tellerProfile" :style="styles">
      <div class="inn">
        <p class="bread-path">
          <span class="link-top" @click="toUranaiTv">占いTV</span>
          > <span class="link-teller" @click="toTeller">占い師名鑑</span>
          > <span class="link-name">{{tellerProfile.name}}</span>
          > <span class="link-lp" @click="toHokatotoLp">{{tellerProfile.mainMethod}}を無料で占う</span>
        </p>
        <h1>{{tellerProfile.name}}<span v-if="tellerProfile.kana">({{tellerProfile.kana}})</span>公式プロフィール</h1>
        <img class="hero" :src="tellerProfile.profilePage.profileImage" :alt="`${tellerProfile.name}（${tellerProfile.kana}）`">

        <dl class="profiles">
          <dt>名前</dt>
          <dd>{{tellerProfile.name}}</dd>
          <dt>本名・出身地・年齢</dt>
          <dd>{{tellerProfile.profilePage.realNameBornPlaceAge}}</dd>
          <dt>経歴</dt>
          <dd v-html="tellerProfile.description"></dd>
          <dt>占術</dt>
          <dd>{{tellerProfile.methods}}</dd>
          <dt>鑑定年数</dt>
          <dd>{{tellerProfile.yearsOfAppraisal}}</dd>
          <dt>鑑定人数</dt>
          <dd>{{tellerProfile.appraisalNum}}</dd>
          <dt>所属</dt>
          <dd>{{tellerProfile.managementOffice.name}}</dd><!-- ※リンクはつけない -->
        </dl>

        <h2>{{tellerProfile.mainMethod}}はどこで占える？</h2>

        <dl class="fortunes">
          <dt>今すぐ占う</dt>
          <dd><span class="link" @click="toHokatotoLp">こちらのリンク</span>から完全無料でご利用いただけます</dd>
          <template v-if="!!tellerProfile.profilePage.directAppraisal">
            <dt>対面鑑定</dt>
            <dd><span v-html="tellerProfile.profilePage.directAppraisal.message"></span></dd>
          </template>
          <template v-if="!!tellerProfile.profilePage.digitalFortune">
            <dt>デジタル占い</dt>
            <dd><span v-html="tellerProfile.profilePage.digitalFortune.name"></span></dd><!-- ※リンクはつけない -->
          </template>
          <template v-if="!!tellerProfile.profilePage.salonTypeCommunity">
            <dt>サロン型コミュニティ</dt>
            <dd><span v-html="tellerProfile.profilePage.salonTypeCommunity.name"></span></dd><!-- ※リンクはつけない -->
          </template>
        </dl>

      </div>
      <lp-footer :menu-list="footerMenuList" />
    </div>
    <div v-else>
      <div class="inn">対象の占い師はいません</div>
    </div>
    <floating-banner-base :show-floating-banner="showFloatingBanner">
      <div class="floating-inner">
        <a href="/recommend/lp/1/basic/input"><img src="/static/img/recommend/lp/kurenotori/banner_words1.svg" alt=""></a>
      </div>
    </floating-banner-base>
  </div>
</template>

<script>
import { BASIC_DATA_BY_LPID, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'
import FloatingBannerBase from '@/utvStore/components/recommend/lp/partials/FloatingBannerBase';

export default {
  name: 'TellerProfile',
  components: {
    FloatingBannerBase,
    LpFooter,
  },
  props: {
    lpId: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      scrollPos: -1,
      showFloatingBannerStart: 0,
    }
  },
  computed: {
    tellerInfo() {
      const info = BASIC_DATA_BY_LPID[this.lpId]
      return !!info ? {...info} : null
    },
    tellerProfile(){
      return !!this.tellerInfo.information && !!this.tellerInfo.information.profile ? this.tellerInfo.information.profile : null
    },
    footerMenuList(){
      return [ ...DEFAULT_FOOTER_MENULIST, ]
    },
    showFloatingBanner(){
      // const flg = !!this.targetInformation && !!this.targetInformation.floatingBanner && this.targetInformation.floatingBanner.enable && this.documentLoaded
      const flg = this.lpId === 1
      const contH = document.body.clientHeight
      const  lim = window.innerHeight + 400
      const start = this.showFloatingBannerStart
      return flg && (this.scrollPos < contH - lim) && (this.scrollPos >= start)
    },
    styles(){
      const sch = this.tellerInfo.colorScheme
      return {
        '--key-color': !!sch.profileKeyColor ? sch.profileKeyColor : sch.second
      }
    },
  },
  mounted() {
    setTimeout(()=>{
      const ft = document.querySelector('.footer')
      ft.style.display = 'none'
    })
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  methods: {
    toUranaiTv(){
      location.href = this.$handoverParams('/')
    },
    toTeller(){
      location.href = this.$handoverParams('/teller')
    },
    toHokatotoLp(){
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
    onScroll(){
      this.scrollPos = window.scrollY
    },
  }
}
</script>

<style scoped lang="scss">
$l_col_keycolor: var(--key-color);
.teller-profile {
  color: #32373F;
  .inn {
    padding: 20px 20px 60px;
    margin: 0 auto;
  }
  .bread-path {
    margin: 0 -10px 20px 0;
    font-size: 13px;
    line-height: 21px;
    color: #656D78;
    .link-top,
    .link-teller,
    .link-lp {
      text-decoration-line: underline;
      cursor: pointer;
    }
    .link-name {
      font-weight: 700;
    }
    .link-lp {
      letter-spacing: -0.5px;
    }
  }
  h1 {
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    margin: 0 0 8px;
  }
  h2 {
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    margin: 0 0 18px;
  }
  .hero {
    max-width: 100%;
    vertical-align: middle;
    margin: 0 auto 18px;
  }
  .profiles,
  .fortunes {
    padding: 0;
    margin: 0;
    > dt {
      font-weight: 700;
      font-size: 14px;
      line-height: 16px;
      text-align: justify;
      padding: 0 0 0 8px;
      border-left: 4px solid $l_col_keycolor;
      margin: 0 0 7px;
    }
    > dd {
      margin: 0 0 18px;
      font-size: 14px;
      line-height: 24px;
      text-align: justify;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    .link {
      font-weight: 700;
      text-decoration-line: underline;
    }
  }
  .profiles {
    margin-bottom: 40px;
  }
}
.floating-inner {
  width: 100%;
  background: rgba(255,255,255,0.8);
  padding: 16px 0 12px;
  img {
    display: block;
    width: 200px;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/teller/TellerProfile.vue